// The shipper's Load Feedback form overrides the carrier's; the carrier's is the fallback when the
// shipper hasn't authored one.
export const resolveLoadFeedbackQuestions = ({ questions = [], shipperId, carrierId }) => {
    const shipperQuestions = shipperId ? questions.filter((q) => q.client_id === shipperId) : [];
    if (shipperQuestions.length > 0) return shipperQuestions;
    return carrierId ? questions.filter((q) => q.client_id === carrierId) : [];
};

const RESPONSE_COLUMNS = {
    boolean: 'response_boolean',
    number: 'response_number',
    string: 'response_string',
};

export const responseColumn = (responseType) => RESPONSE_COLUMNS[responseType] || RESPONSE_COLUMNS.string;

export const responseValue = (responseType, response = {}) => response[responseColumn(responseType)];

// Upsert rows for the answers the draft changed; untouched questions aren't sent.
export const buildSurveyResponseObjects = ({ questions = [], responses = {}, draft = {}, manifest_id }) =>
    questions
        .filter(
            (q) => q.survey_id in draft && draft[q.survey_id] !== responseValue(q.response_type, responses[q.survey_id])
        )
        .map((q) => ({
            survey_id: q.survey_id,
            manifest_id,
            [responseColumn(q.response_type)]: draft[q.survey_id],
        }));
